// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import * as twilioAPI from 'api/twilio';
import * as alertSnackbar from 'utils/snackbar-wrapper';

const initialState = {
    error: false,
    loaded: false,
    data: {
        enabled: false,
        callerId: null
    }
};

const slice = createSlice({
    name: 'twilioOutboundCallingConfig',
    initialState,
    reducers: {
        setConfigError(state) {
            state.error = true;
            state.loaded = true;
        },
        setConfig(state, action) {
            state.error = false;
            state.loaded = true;
            state.data = action.payload;
        },
        resetConfigState() {
            return initialState;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function resetTwilioOutboundCallingConfigState() {
    dispatch(slice.actions.resetConfigState());
}

export function getTwilioOutboundCallingConfig(clinicId) {
    return async () => {
        const response = await twilioAPI.getOutboundCallingConfig(clinicId);
        if (response?.data && typeof response.data.enabled === 'boolean') {
            dispatch(slice.actions.setConfig(response.data));
        } else {
            // `response.message` only exists on the API's error return; a malformed 200 body
            // (unexpected shape) is the raw axios response with no `.message`, so guard it.
            const reason = response?.message ?? 'unexpected response';
            dispatch(alertSnackbar.error(`Failed to fetch outbound calling config: ${reason}`));
            dispatch(slice.actions.setConfigError());
        }
    };
}
